// src/authConfig.js
import { LogLevel } from "@azure/msal-browser";

export const msalConfig = {
  auth: {
    // Frontend Client ID
    clientId: '2204f336-b1bc-4b78-b61b-68efc62784ae',
    // Tenant ID
    authority: 'https://login.microsoftonline.com/332759ea-2a45-492d-a599-06d7c83259ad',
    // Dynamic redirect URI based on current environment
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      }
    }
  }
};

export const loginRequest = {
  scopes: ["User.Read"],
};

// Add this for calling your backend API
export const apiRequest = {
  // YOUR_BACKEND_CLIENT_ID
  scopes: ["api://ce5fe674-8d3e-4e71-b353-aae27b6913a5/access_as_user"], // Replace YOUR_BACKEND_CLIENT_ID with your actual backend client ID
};

export const apiConfig = {
  // Use full URL for development, relative path for production
  apiBaseUrl: process.env.NODE_ENV === 'development' 
    ? 'http://localhost:4000/api' 
    : '/api',
};